import loading from './loading';
import app from './app';
import auth from './auth';
import affiliates from './affiliates';
import locations from './locations';
import * as workorders from './workorders';
import requests from './requests';
import notify from './notify';
import refresh from './refresh';
import attachments from './attachments';
import nativeLogging from './nativeLogging';
import setHeaderTitle from './header';
import setHelpPage from './help';

export default Object.assign({},
  loading,
  app,
  auth,
  affiliates,
  locations,
  requests,
  workorders,
  notify,
  refresh,
  attachments,
  { nativeLogging },
  setHeaderTitle,
  setHelpPage,
);



// WEBPACK FOOTER //
// ./src/state/actions/index.js